export default __webpack_public_path__ + "static/media/logo8.81979a32.svg";